export default "__VITE_ASSET__oE4R5PgU__"